import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';

const EmailModal = ({ isOpen, onClose, onSend, ambassadorEmailLists, initialRecipients = [] }) => {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [recipientType, setRecipientType] = useState('all'); // all, default, custom

  const isGeneralMessageMode = ambassadorEmailLists && (ambassadorEmailLists.default.length > 0 || ambassadorEmailLists.custom.length > 0);

  useEffect(() => {
    // Réinitialiser le type de destinataire si on passe en mode email simple
    if (isOpen && !isGeneralMessageMode) {
      setRecipientType('initial');
    }
    if (isOpen && isGeneralMessageMode) {
        setRecipientType('all');
    }
  }, [isOpen, isGeneralMessageMode]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    let finalRecipients = [];
    if (isGeneralMessageMode) {
        switch (recipientType) {
            case 'default':
                finalRecipients = ambassadorEmailLists.default;
                break;
            case 'custom':
                finalRecipients = ambassadorEmailLists.custom;
                break;
            case 'all':
            default:
                finalRecipients = [...new Set([...ambassadorEmailLists.default, ...ambassadorEmailLists.custom])];
                break;
        }
    } else {
        finalRecipients = initialRecipients;
    }

    if(finalRecipients.length === 0) {
        alert('Aucun destinataire à qui envoyer le message.');
        return;
    }

    onSend(subject, body, finalRecipients);
    setSubject('');
    setBody('');
    onClose(); // Fermer la modale après envoi
  };  

  return (
      <div className="modal-overlay" onClick={onClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close-btn" onClick={onClose}>
                  <FaTimes />
              </button>
              <h3>Envoyer un Email</h3>
              {isGeneralMessageMode && (
                <div className="recipient-options" style={{ marginBottom: '15px', paddingBottom: '15px', borderBottom: '1px solid #eee' }}>
                  <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>Choisir les destinataires :</label>
                  <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                    <label>
                      <input type="radio" value="all" checked={recipientType === 'all'} onChange={() => setRecipientType('all')} />
                      Tous les Ambassadeurs
                    </label>
                    <label>
                      <input type="radio" value="default" checked={recipientType === 'default'} onChange={() => setRecipientType('default')} />
                      Défaut
                    </label>
                    <label>
                      <input type="radio" value="custom" checked={recipientType === 'custom'} onChange={() => setRecipientType('custom')} />
                      Personnalisé
                    </label>
                  </div>
                </div>
              )}
              <form onSubmit={handleSubmit} className="email-form">
                  <div className="form-group">
                      <label htmlFor="emailSubject">Titre / Objet:</label>
                      <input
                          type="text"
                          id="emailSubject"
                          value={subject}
                          onChange={(e) => setSubject(e.target.value)}
                          required
                      />
                  </div>
                  <div className="form-group">
                      <label htmlFor="emailBody">Message:</label>
                      <textarea
                          className="zonetext"
                          id="emailBody"
                          value={body}
                          onChange={(e) => setBody(e.target.value)}
                          rows="8"
                          required
                      ></textarea>
                  </div>
                  <button type="submit" className="envoisgeneral">
                      Envoyer
                  </button>
              </form>
          </div>
      </div>
  );
};

export default EmailModal;
